import React from 'react';
import "./PlayerArea.css"
import playersData from "../Data/Data"
import { useEffect, useState } from 'react';
import Cart from '../Cart/Cart';
import Player from '../Player/Player';

const PlayerArea = () => {
    const [players, setPlayers] = useState([])
    const [cart,setCart]=useState([])
    useEffect(() => {
        console.log("Loading data")
        setPlayers(playersData)
    }, [])
    const addCart=(props)=>{
        const newCart =[...cart,props]
        setCart(newCart)
    }
    return (
        <div className="PlayerArea">
            <div className="singlePlayer">
                <h3 style={{textAlign:"center"}}>Draft Players:</h3>
                {
                    players.map(player => <Player addCart={addCart} player={player}></Player>)
                }
            </div>
            <div className="Cart">
                <Cart cart={cart}></Cart>
            </div>
            
        </div>
    );
};

export default PlayerArea;